module.exports = __webpack_public_path__ + "static/media/lottery_logo.b1836278.png";